import { ComponentType, useContext } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { TrackedLink } from 'components/Link/TrackedLink';
import { UpdateRequiredContext } from 'containers/UpdateRequiredContext';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
  to?:
    | string
    | {
        pathname: string;
        state?: Record<string, unknown>;
      };
} & Record<string, unknown>;

export function BaseLink({ component, to, ...props }: Props) {
  const Component = component;

  const isStateless =
    typeof to === 'string' || (typeof to === 'object' && !to.state);

  const updateRequired = useContext(UpdateRequiredContext);

  if (updateRequired && isStateless) {
    return (
      <TrackedLink
        href={typeof to === 'string' ? to : to.pathname}
        eventName="Updating App Version"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component to={to} {...props} />;
}

export function NavLink(props: Omit<Props, 'component'>) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BaseLink component={RouterNavLink} {...props} />;
}

export function Link(props: Omit<Props, 'component'>) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BaseLink component={RouterLink} {...props} />;
}
